import React, { useEffect, useState } from "react";
import { Icon, Intent } from "@blueprintjs/core";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Tooltip } from "components/tooltip";
import './EmployeeCircleStatus.css';
import './Status.css';
import './StatusPanel.css';

export function StatusBadge({
    text,
    iconName,
    intent,
    animated = false,
    showTooltip = false,
    tooltipContent = null,
    tooltipPosition = "auto"
}) {
    const [colour, setColour] = useState("");

    useEffect(() => {
        if (intent) {
            switch (intent.toLowerCase()) {
                case "warning":
                    setColour("#FF9076");
                    break;
                case "info":
                case "primary":
                    setColour("#008CFF");
                    break;
                case "danger":
                    setColour("#F0578A");
                    break;
                case "success":
                    setColour("#00C6B2");
                    break;
                default:
                    setColour("#737373");
                    break;
            }
        }
    }, [intent]);

    return (
        <span className="inline-items">
            <div className="padded-right status-badge-icon-container">
                {showTooltip && tooltipContent ? (
                    <Tooltip content={tooltipContent} position={tooltipPosition}>
                        <div className={classNames({ spin: animated })}>
                            <Icon
                                icon={iconName}
                                size={14}
                                color={colour}
                            />
                        </div>
                    </Tooltip>
                ) : (
                    <div className={classNames({ spin: animated })}>
                        <Icon
                            icon={iconName}
                            size={14}
                            color={colour}
                        />
                    </div>
                )}
            </div>
            {text}
        </span>
    );
}


StatusBadge.propTypes = {
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    iconName: PropTypes.string.isRequired,
    intent: PropTypes.oneOf([
        Intent.NONE,
        Intent.PRIMARY,
        Intent.SUCCESS,
        Intent.WARNING,
        Intent.DANGER,
    ]).isRequired,
    animated: PropTypes.bool,
    showTooltip: PropTypes.bool,
    tooltipContent: PropTypes.any,
    tooltipPosition: PropTypes.string,
};
